import revealableContent from "./_revealableContent.script";

revealableContent.init({
    // Customize settings here
});
